module.exports = __webpack_public_path__ + "static/media/fill-1.c8609bc5.svg";